import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import Config from 'config';
import template from 'hbars!templates/trackView';

var AgendaTrackView = Backbone.View.extend({

    events: {
        'click': 'toggleDisable',
        'click .dropdown-display-this': 'displayTrackClicked'
    },

    className: 'color-5-background',

    initialize: function(options) {
        this.listenTo(this.model, 'change:disabled', this.render);
    },

    displayTrackClicked: function() {
        var thisView = this;
        this.collectionListView.collection.each(function(track) {
            track.set('disabled', (track.get('id') != thisView.model.get('id')));
        });
    },

    toggleDisable: function(e) {
        var el = $(e.target);
        if (el.hasClass('track-drop-down') || el.hasClass('icon-down') || el.is('a')) {
            return;
        }
        this.model.set('disabled', !this.model.get('disabled'));
    },

    render: function() {
        var html = template(this.model.toJSON());
        this.$el.html(html);
        this.$el.toggleClass('disabled', this.model.get('disabled'));
        return this;
    }

});

export default AgendaTrackView;

